import request from '@/utils/request'

// 获取API权限配置列表
export function getApiPermissionList(params) {
  return request({
    url: '/apiPermissionConfig/list',
    method: 'get',
    params
  })
}

// 分页查询API权限配置
export function getApiPermissionPage(currentPage, pageSize, params) {
  return request({
    url: `/apiPermissionConfig/page?currentPage=${currentPage}&pageSize=${pageSize}`,
    method: 'get',
    params
  })
}

// 根据ID获取API权限配置
export function getApiPermissionById(id) {
  return request({
    url: `/apiPermissionConfig/${id}`,
    method: 'get'
  })
}

// 新增API权限配置
export function addApiPermission(data) {
  return request({
    url: '/apiPermissionConfig',
    method: 'post',
    data
  })
}

// 修改API权限配置
export function updateApiPermission(data) {
  return request({
    url: '/apiPermissionConfig',
    method: 'put',
    data
  })
}

// 删除API权限配置
export function deleteApiPermission(ids) {
  return request({
    url: `/apiPermissionConfig/${ids}`,
    method: 'delete'
  })
}

// 获取API权限字段列表
export function getApiPermissionFields() {
  return request({
    url: '/apiPermissionConfig/fieldTree',
    method: 'get'
  })
}